import { createCRUDHook } from './createCRUDHook';
import { PartColorImageDto } from 'utils/models';
import { ECG_PART_COLOR_IMAGE } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<PartColorImageDto>({
  entityName: 'PartColorImage',
  endpoint: ECG_PART_COLOR_IMAGE,
});

export const PartColorImageContext = Context;
export const usePartColorImageManager = useManager;
export const usePartColorImage = useConsumer;
